module.exports = __webpack_public_path__ + "static/media/triple-tigers.fce17c69.gif";